import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const RangeAnswers = ({ answers, question, onSelect, setAnswer }) => {
    const { t } = useTranslation("tests");

    const effectiveAnswers = question.answers;

    const min = parseInt(effectiveAnswers[0].code);
    const max = parseInt(effectiveAnswers[effectiveAnswers.length - 1].code);
    const defaultValue = Math.ceil((min + max) / 2);
    const [value, setValue] = useState(defaultValue);
    const [touched, setTouched] = useState(false);

    useEffect(() => {
        if (question && answers[0]) {
            const findValue = effectiveAnswers.find(({ id }) => id === answers[0]);
            const savedValue = findValue ? parseInt(findValue.code) : defaultValue;
            setValue(savedValue);
            setTouched(true);
        } else {
            setValue(defaultValue);
            setTouched(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [answers]);

    const handleChange = (e) => {
        const answer = effectiveAnswers.find(({ code }) => code === e.target.value);
        if (answer) {
            setValue(parseInt(answer.code));
            setAnswer(answer.id);
            setTouched(true);
        }
    };

    const handleNext = () => {
        const answer = effectiveAnswers.find(({ code }) => parseInt(code) === value);
        if (answer) {
            onSelect(answer.id);
        }
    };

    const fillPercent = max > min ? ((value - min) / (max - min)) * 100 : 0;
    const trackStyle =
        value > min
            ? {
                  background: `linear-gradient(to right, #21bcfb 0%, #21bcfb ${fillPercent}%, #d4dcf0 ${fillPercent}%, #d4dcf0 100%)`,
              }
            : {};

    const useTicks = useCallback(() => {
        const codes = effectiveAnswers.map((a) => parseInt(a.code));
        const minCode = codes[0];
        const maxCode = codes[codes.length - 1];
        const range = maxCode - minCode;
        const centerCode = Math.round(minCode + range / 2);

        return effectiveAnswers.map((ans, i) => {
            const tickNum = parseInt(ans.code);
            const isMilestone =
                tickNum === minCode ||
                tickNum === maxCode ||
                tickNum === centerCode;
            const isPassed = tickNum > minCode && tickNum <= value;
            const isActive = tickNum === value;

            const cls = `range-new-tick${isPassed ? " range-new-tick--passed" : ""}${isActive ? " range-new-tick--active" : ""}`;

            const thumbSize = 37;
        const tickPosition = `calc(${thumbSize / 2}px + ${i} / ${effectiveAnswers.length - 1} * (100% - ${thumbSize}px))`;

        return (
                <div key={i} className={cls} style={{ '--tick-position': tickPosition }}>
                    <div className="range-new-tick__bar" />
                    {isMilestone && (
                        <span className="range-new-tick__label">{tickNum}</span>
                    )}
                </div>
            );
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [question, value]);

    return (
        <div className="range-new-wrapper">
            <div className="range-new-track">
                <input
                    onChange={handleChange}
                    className={`range-new-slider${value > min ? " range-new-slider--selected" : ""}`}
                    style={trackStyle}
                    type="range"
                    min={min}
                    max={max}
                    value={value}
                />
                <div className="range-new-ticks">{useTicks()}</div>
            </div>
            <p className="range-new-hint">{t("drag_slider")}</p>
            <button
                className="range-new-btn"
                disabled={!touched}
                onClick={handleNext}
            >
                ✓ Готово
            </button>
        </div>
    );
};
